import React from "react";
// import MyProfileLeftContent from "components/myprofile/leftcontent/";
import MyProfileRightContent from "components/myprofile/rightcontent/";

const MainContent = (props) => {
  return (
    <div id="myprofile-content" className="inner-container row">
      {/* <MyProfileLeftContent /> */}
      <MyProfileRightContent />
    </div>
  );
};

export default MainContent;
